import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke323aRequest, Sgke323aResponse, Sgke323aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke323aService {

  /**
   * コンストラクタ
   * @param {Sgke323aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke323aService
   */
  constructor(
    private service: Sgke323aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * SGKE323A_供給停止作業割当登録API呼び出し
   * @param {Sgke323aRequest} request
   * @return {*}  {Observable<Sgke323aResponse>}
   * @memberof UsedSgke323aService
   */
  public doSgke323a(request: Sgke323aRequest): Observable<Sgke323aResponse> {
    return this.service.sgke323aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE323A');
          return throwError(err.message);
        })
      );
  }
}
